<style lang="less">
.pd-prop{
  display: flex;
  height:25px;
  border-bottom:1px solid #00000011;
  border-image: linear-gradient(to right, #41404433, #b2b4bb,#b2b4bb) 1;
  font-family: 'PingFang-SC';

  .pd-label{
    display: flex;
    align-items: center;
    justify-content: center;
    width:80px;
    font-size:12px;
    border-right:1px solid var(--border);
  }
  .pd-label--has-tip {
    cursor: help;
    .pd-label-text {
      border-bottom: 1px dashed var(--subtext2, #999);
    }
  }
  .pd-label-text {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 2px;
  }
   .pd-value{
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    overflow: hidden;
    font-size:12px;
    color:var(--text2);

    width:calc(100% - 80px);
  }

  .pd-value:hover{
    cursor: text;
  }
}

.pm-embed-control,.pd-embed-control{
  position: relative;
  height:100% !important;
  width:100%;
  overflow: hidden;

  background:#ffffffdd;
  .ivu-dropdown{
    display:block !important;
    height:100%;
  }
  .ivu-dropdown-rel{
    height:100%;
  }

  .value-wrap{
    padding-left:11px;background:rgb(239, 239, 201);height:100%;font-size:12px;width:100%;color:rgb(163, 163, 163);line-height:28px
  }

}

.pd-embed-control-editable{
  background:#fff !important;
}


.pd-embed-value{
  height:100%;
  width:100%;
  padding:0 10px;
  color:var(--text1, #333);
  cursor:default;
  font-size:12px;
  white-space:nowrap;
  text-overflow: ellipsis;
  overflow:hidden;
  align-items: center;
}

.pd-embed-empty-value{
  color:var(--subtext2);
  font-weight: normal;
}


</style>
<template>
  <div style="overflow:hidden;width:100%;">
    <div style="overflow:hidden">
       <template v-for="(p,i) in props">
      <div class="pd-prop" :style="p.control=='DetailSelect'?'height:60px':(p.control=='TplString'?'height:78px':'')" :key="'pi'+i+p.key">
        <div class="pd-label" :class="{'pd-label--has-tip': !!p.desc}">
          <Tooltip
            v-if="p.desc"
            :content="p.desc"
            placement="left"
            transfer
            max-width="260"
          >
            <span class="pd-label-text">{{p.label}}</span>
          </Tooltip>
          <span v-else class="pd-label-text">{{p.label}}</span>
        </div>
        <div class="pd-value">
          <template v-if="p.control">
            <component
              :is="`Pe${p.control || 'Text'}`"
              :option="p.option"
              :editable="!disabledAll && !p.disabled && !disabled[p.key]"
              :value="value[p.key]"
              :db="value"
              @input="handleChange(p.key,$event)" @save="$emit('save')"
              :env="env"
            />
          </template>
          <template v-else>
            {{value[p.key] || ''}}
          </template>
          </div>
      </div>
      </template>
    </div>
  </div>
</template>

<script>
import PeText from '@/components/pd/Controls/Text';
import PeColumnDesign from '@/components/pd/Controls/ColumnDesign';
import PeCheck from '@/components/pd/Controls/Check';
import PeSelectOption from '@/components/pd/Controls/SelectOption';
import PeState from '@/components/pd/Controls/State';
import PeSelect from '@/components/pd/Controls/Select';
import PeFormSelect from '@/components/pd/Controls/FormSelect';
import PeTutorialSelect from '@/components/pd/Controls/TutorialSelect';
import PeFlowSelect from '@/components/pd/Controls/FlowSelect';
import PeTaskSelect from '@/components/pd/Controls/TaskSelect';
import PeTextarea from '@/components/pd/Controls/Textarea';
import PeFiles from '@/components/pd/Controls/Files';
import PeFile from '@/components/pd/Controls/File';
import PeDate from '@/components/pd/Controls/Date';
import PeUserSelect from '@/components/pd/Controls/UserSelect';
import PeCloneDefaultUsers from '@/components/pd/Controls/CloneDefaultUsers';
import PeDetailSelect from '@/components/pd/Controls/DetailSelect';
import PeFieldSelect from '@/components/pd/Controls/FieldSelect';
import PePermissionSelect from '@/components/pd/Controls/PermissionSelect';
import PeMText from '@/components/pd/Controls/MText';
import PeFormPermission from '../pd/Controls/FormPermissions.vue';
import PeDefaultValue from '@/components/pd/Controls/DefaultValue';
import PeACLSelect from '@/components/pd/Controls/ACLSelect';
import PeSignatureSetting from '@/components/pd/Controls/SignatureSetting';
import PeZZLColumnDesign from '@/components/pd/Controls/ZZLColumnDesign';
import PeNumber from '@/components/pd/Controls/Number';
import PeTimeout from '@/components/pd/Controls/Timeout';
import PeDataSourceSelect from '@/components/pd/Controls/DataSourceSelect';
import PeZZLAPIParamsEditor from '@/components/pd/Controls/ZZLAPIParamsEditor';
import PeZZLFile from '@/components/pd/Controls/ZZLFile';
import PeZZLFormPositionBindingSelect from '@/components/pd/Controls/ZZLFormPositionBindingSelect';
import PeZZLJoinTableSelect from '@/components/pd/Controls/ZZLJoinTableSelect';
import PeTplString from '@/components/pd/Controls/TplString';
export default {
  components: {
    PeText, PeSelect, PeState, PeFormSelect,PeNumber, PeTimeout, PeTaskSelect,PeZZLColumnDesign, PeTutorialSelect, PeFlowSelect, PeCheck, PeSelectOption, PeColumnDesign, PeTextarea, PeFiles, PeFile, PeDate, PeUserSelect, PeCloneDefaultUsers, PeDetailSelect, PeFieldSelect, PePermissionSelect, PeMText, PeFormPermission, PeDefaultValue, PeACLSelect, PeSignatureSetting,PeDataSourceSelect, PeZZLAPIParamsEditor, PeZZLFile, PeZZLFormPositionBindingSelect, PeZZLJoinTableSelect, PeTplString
  },
  props: {
    value: {
      type: Object,
      default: ()=>({}),
    },
    attrs: {
      type: Array,
      default: ()=>({}),
    },
    disabled: {
      type: Object,
      default: ()=>({}),
    },
    disabledAll: {
      type: Boolean,
    },
    env: {
      type: Object,
      default: ()=>({}),
    },
  },
  watch: {
    value: {
      handler(v) {
        this.$forceUpdate();
      },
    },
  },
  methods: {
    handleChange(key, v) {
      let next = v;
      if (v != null && typeof v === 'object') {
        try {
          next = JSON.parse(JSON.stringify(v));
        } catch (e) {
          // 保底：浅拷贝可枚举字段，丢掉不可序列化引用
          next = Array.isArray(v) ? [...v] : {...v};
        }
      }
      this.$set(this.value, key, next);
      this.$emit('input', this.value);
      this.$emit('on-change', {
        key,
        value: next,
      });
    },
  },
  computed: {
    props() {
      if (Array.isArray(this.attrs) && this.attrs.length > 0) {
        return this.attrs;
      } else {
        return [];
      }

      if (!this.value || Object.keys(this.value).length == 0) {
        return [];
      }
      return Object.keys(this.value).map((key)=>{
        return {
          key,
          label: key,
          control: 'Text',
          option: {},
          editable: true,
        };
      });
    },
  },
};
</script>

